module.exports = __webpack_public_path__ + "img/smart-scan-char-1.404ada67.png";